module.exports = __webpack_public_path__ + "static/img/vd-11.49686cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/m8/vd-11.png
// module id = zqyy
// module chunks = 1